import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import type { Profession } from '@/types/worker';

export const useProfessions = () => {
    return useQuery({
        queryKey: ['professions'],
        queryFn: async (): Promise<Profession[]> => {
            const { data } = await api.get(API_ROUTES.professions);
            return data;
        },
        staleTime: 30 * 60 * 1000,
    });
};
